<template>
  <div>
    <form id="contact_form" class="form contact-form" v-on:submit.prevent="submit"
          v-show="!send">
      <div class="form-wrapper">
        <div class="form-column">
          <div class="floating-form">

            <div class="floating-label required" :class="{ 'form-group--error': $v.name.$error }">
              <input class="floating-input" type="text" placeholder=" "
                     v-model.trim="$v.name.$model" name="name" @input="$v.name.$touch()">
              <span class="highlight"></span>
              <label for="name">Nome</label>
              <div class="error" v-if="!$v.name.required">Nome richiesto.</div>
            </div>

            <div class="floating-label required" :class="{ 'form-group--error': $v.surname.$error }">
              <input class="floating-input" type="text" placeholder=" " v-model.trim="$v.surname.$model"
                     name="surname"
                     @input="$v.surname.$touch()">
              <span class="highlight"></span>
              <label for="surname">Cognome</label>
              <div class="error" v-if="!$v.surname.required">Cognome richiesto</div>
            </div>

            <div class="floating-label">
              <input class="floating-input" type="text" placeholder=" "
                   name="company_name" v-model.trim="company_name">
              <span class="highlight"></span>
              <label for="company_name">Company Name</label>
            </div>

            <div class="floating-label required" :class="{ 'form-group--error': $v.phone.$error }">
              <input class="floating-input" type="text" placeholder=" " v-model.trim="$v.phone.$model"
                     name="phone"
                     @input="$v.phone.$touch()">
              <span class="highlight"></span>
              <label for="phone">Telefono</label>
              <div class="error" v-if="!$v.phone.required">Telefono richiesto</div>
            </div>

            <div class="floating-label required" :class="{ 'form-group--error': $v.email.$error }">
              <input class="floating-input" v-model.trim="$v.email.$model" type="email"
                     name="email"
                     placeholder=" "
                     @input="$v.email.$touch()">
               <span class="highlight"></span>
              <label for="email">Email</label>
              <div class="error" v-if="!$v.email.required">Email richiesto</div>
              <div class="error" v-if="!$v.email.email">Email non corretta</div>
            </div>

          </div>
        </div>
        <div class="form-column">
          <div class="row" :class="{ 'form-group--error': $v.message.$error }">
            <label for="message">Messaggio</label>
            <textarea v-model="$v.message.$model" name="message"
                      @input="$v.message.$touch()">
            </textarea>
            <div class="error" v-if="!$v.message.required">Inserisci un messaggio</div>
          </div>
        </div>

        <div class="row-actions">
          <div class="row-privacy required" :class="{ 'form-group--error': $v.privacy.$error }">
            <input v-model="$v.privacy.$model" name="privacy" type="checkbox" value="1"
                   @input="$v.privacy.$touch()">
            <label>Accetto la <router-link target="_blank" :to="{ name: 'privacy-policy'}">Privacy policy</router-link></label>
            <div class="error" v-if="!$v.privacy.checked">Necessario accettare la privacy policy</div>
          </div>
          <button type="submit" class="btn btn-primary" :disabled="submitStatus === 'PENDING'">Invia</button>
        </div>

      </div>
    </form>
    <div class="submit-message ok" v-if="submitStatus === 'OK'">
      <p>Grazie. Messaggio inviato.</p>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import {required, email} from 'vuelidate/lib/validators'

  export default {
    name: 'ContactForm',
    data() {
      return {
        name: '',
        surname: '',
        email: '',
        message: '',
        phone: '',
        company_name: '',
        privacy: false,
        maxLength: 140, // maximum length of the form message
        send: false,
        submitStatus: null
      }
    },
    validations: {
      name: {
        required
      },
      surname: {
        required
      },
      email: {
        required, email
      },
      phone: {
        required
      },
      message: {
        required
      },
      privacy: {
        checked (val) {
          return val
        }
      },
    },
    methods: {
      submitForm() {
        let sthis = this
        axios.post('https://contactsgabiano.sixeleven.it/api/contact/add', {
          name: this.name,
          surname: this.surname,
          email: this.email,
          phone: this.phone,
          message: this.message,
          company_name: this.company_name,
          privacy: this.privacy,
        })
            .then(function (response) {
              if (response.status === 200) {
                sthis.send = true
              }
              else if (response.status === 422) {

              }
              else {
                sthis.send = false
              }
            })
            .catch(function (error) {

            });

      },
      submit() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.submitStatus = 'ERROR'
        }
        else {
          // do your submit logic here
          this.submitStatus = 'PENDING'
          setTimeout(() => {
            this.submitForm()
            this.submitStatus = 'OK'
          }, 500)
        }
      }
    }
  }
</script>
